import { render, staticRenderFns } from "./AvatarCard.vue?vue&type=template&id=325624eb&"
import script from "./AvatarCard.vue?vue&type=script&lang=js&"
export * from "./AvatarCard.vue?vue&type=script&lang=js&"
import style0 from "./AvatarCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports